import { useState } from "react";
import { Languages, X } from "lucide-react";

/* One-tap language bar for the Travel to India guides — sets the googtrans
   cookie and triggers the (already-loaded) Google Translate combo, same
   mechanism as the global Translate control in the IA header. */

const LANGS = [
  ["hi", "हिन्दी"], ["ml", "മലയാളം"], ["ta", "தமிழ்"], ["te", "తెలుగు"], ["kn", "ಕನ್ನಡ"],
  ["bn", "বাংলা"], ["mr", "मराठी"], ["gu", "ગુજરાતી"], ["pa", "ਪੰਜਾਬੀ"], ["ur", "اردو"],
];

const current = () => {
  const m = document.cookie.match(/(?:^|;\s*)googtrans=\/en\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "";
};

export default function IALangBar() {
  const [lang, setLang] = useState(current);

  const change = (code) => {
    setLang(code);
    const host = window.location.hostname;
    if (!code) {
      const expire = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = `googtrans=;path=/;${expire}`;
      const parts = host.split(".");
      for (let i = 0; i < parts.length - 1; i++) {
        const d = parts.slice(i).join(".");
        document.cookie = `googtrans=;path=/;domain=${d};${expire}`;
        document.cookie = `googtrans=;path=/;domain=.${d};${expire}`;
      }
      window.location.reload();
      return;
    }
    const v = `/en/${code}`;
    document.cookie = `googtrans=${v};path=/`;
    document.cookie = `googtrans=${v};path=/;domain=${host}`;
    document.cookie = `googtrans=${v};path=/;domain=.${host}`;
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
    } else {
      window.location.reload();
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5 notranslate" translate="no" data-testid="ia-lang-bar">
      <span className="inline-flex items-center gap-1 text-[10px] font-800 uppercase tracking-wide text-zinc-400">
        <Languages className="w-3.5 h-3.5 text-blue-600" /> Read in
      </span>
      {LANGS.map(([code, label]) => (
        <button key={code} onClick={() => change(code)} data-testid={`ia-lang-${code}`}
          className={`text-xs font-700 rounded-full px-2.5 py-1 border transition-colors ${lang === code ? "bg-blue-700 text-white border-blue-700" : "bg-white text-zinc-600 border-zinc-300 hover:border-blue-400 hover:text-blue-700"}`}>
          {label}
        </button>
      ))}
      {lang && (
        <button onClick={() => change("")} data-testid="ia-lang-reset"
          className="inline-flex items-center gap-1 text-xs font-700 rounded-full px-2.5 py-1 border border-zinc-300 bg-white text-zinc-500 hover:text-blue-700 hover:border-blue-400">
          <X className="w-3 h-3" /> English
        </button>
      )}
    </div>
  );
}
